// @ts-nocheck
import React, { createRef } from "react";
import RoutingComponent from "../../../../base/common/RoutingComponent";
import styles from "../index.module.scss";
import PageHeader from "../../../commonComponents/pageHeaders/PageHeader";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import ApproveProcedureInformation from "../../../sections/procedureInfoSections/approveProcedureInfoSection";
import { actions, shareTaskMassage } from "../../../publicDictionaryValues";
import TaskInformation from "../../../sections/taskInfoSections";
import ReadOnlyProcedureFileSection from "../../../sections/procedureFileSections/readOnlyProcedureFileSection";
import ReadOnlySupportingFileSection from "../../../sections/supportingFileSections/readOnlySupportingFileSection";
import ActiveShareTaskReadOnly from "../../../sections/sharedTaskSections/activeShareTaskReadOnly";
import Buttons from "../../../../base/basicComponents/button";
import NormalToolTip from "../../../../base/basicComponents/toolTip";
import redTipIcon from "../../../../assets/image/redTipIcon.png";
import ApproveChangePPOService from "../../../../service/changePPO/ApproveChangePPOService";
import appService from "../../../../service/app";
import LostPermissionModal from "../../../sections/lostPermissionModal";
import StepService from "../../../../service/stepBase/StepService";
import StepBusinessType from "../../../../service/stepBase/stepBusinessType";

const procedureFileRef = createRef();
const supportingFileRef = createRef();
const supportingFileTableRef = createRef();
const procedureInfoRef = createRef();
export default class ApprovePPOPending extends RoutingComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      procedureInfoState: {},
      modalState: {
        isReturnModalOpen: false,
        isRejectModalOpen: false,
        isModalOpen: false,
        modalOkText: "",
        modalCancelText: "",
        modalChildContent: "",
        handleModalConfirm: () => {},
        handleModalCancel: () => {},
      },
      noPermission: false,
    };
    // @ts-ignore
    this.procedureTaskId = this.props.procedureTaskId;
    // @ts-ignore
    this.procedureID = this.props.procedureID;
    // @ts-ignore
    this.procedureStepID = this.props.procedureStepID;
  }

  toggleReturnModal = (value: any) => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isReturnModalOpen: value,
      },
    });
  };

  toggleRejectModal = (value: any) => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isRejectModalOpen: value,
      },
    });
  };

  toggleNormalModal = (value: any) => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isModalOpen: value,
      },
    });
  };

  _checkStepPermissionSuccess = (result: any, actionType: any) => {
    const { statusCode } = result;
    const noPermission = statusCode !== 200;
    this.setState({
      noPermission,
    });
    if (noPermission) {
      this.props._hideLoading();
      return;
    }
    if (actionType === "reject") {
      this.props._hideLoading();
      this.toggleRejectModal(true);
    } else {
      this.checkPpoLostMembership(actionType);
    }
  };

  checkStepPermission = (actionType: any) => {
    this.props._showLoading();
    const param = {
      // @ts-ignore
      taskID: this.procedureTaskId,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      parentPage: null,
    };
    appService.checkStepPermission(
      param,
      (response: any) => this._checkStepPermissionSuccess(response, actionType),
      (response: any) => console.log(response.message)
    );
  };

  _checkPpoLostMembershipSuccess = (response: any, actionType: any) => {
    this.props._hideLoading();
    if (response.result) {
      if (actionType === "approve") {
        this.handelApproveClick();
      } else if (actionType === "return") {
        this.toggleReturnModal(true);
      }
    } else {
      // @ts-ignore
      const message = shareTaskMassage[response.messageCode];
      this._alertError(message, 7);
    }
  };

  checkPpoLostMembership = (actionType: any) => {
    const { primaryProcedureOwner } = this.props.stepItemData;
    const param = {
      procedureAccountId: this.props.taskInformationData.procedureAccountID,
      oldPrimaryProcedureOwnerId: primaryProcedureOwner.oldPrimaryProcedureOwnerID,
      newPrimaryProcedureOwnerId: primaryProcedureOwner.primaryProcedureOwnerID,
      // @ts-ignore
      actionId: actions[actionType],
      action: 0,
      // @ts-ignore
      procedureId: this.procedureID,
    };
    ApproveChangePPOService.checkPpoLostMembership(
      param,
      (response: any) => this._checkPpoLostMembershipSuccess(response, actionType),
      () => this._alertError("CheckPpoLostMembership Failed")
    );
  };

  handelApproveClick = () => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isModalOpen: true,
        modalOkText: "Confirm",
        modalCancelText: "Cancel",
        modalChildContent: "Are you sure to approve this request?",
        handleModalConfirm: this.handleApproveConfirm,
        handleModalCancel: () => this.toggleNormalModal(false),
      },
    });
  };

  handleApproveConfirm = () => {
    this.props._showLoading();
    const { workflowProcessInstanceId } = this.props.procedureInformationData.procedureInfoState;
    const param = {
      // @ts-ignore
      procedureId: this.procedureID,
      actionID: actions.approve,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      workflowProcessInstanceId,
    };

    ApproveChangePPOService.ChangePrimaryProcedureOwnerTriggerStepAction(
      param,
      this.props.closePage,
      (response: any) => {
        this._alertError(response.message);
      }
    );

    this.toggleNormalModal(false);
  };

  handleCancelClick = () => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isModalOpen: true,
        modalOkText: "Confirm",
        modalCancelText: "Cancel",
        modalChildContent: "Are you sure to quit without saving?",
        handleModalConfirm: () => this.props.closePage(),
        handleModalCancel: () => this.toggleNormalModal(false),
      },
    });
  };

  render() {
    const {
      procedureInformationData,
      supportingTableData,
      jbProcedureSavedIn,
      taskInformationData,
    } = this.props;
    const { procedureTableData, clientServerPath, savedInRadioValue } =
      this.props.procedureFileData;
    const { receiveDate, requestByName } = procedureInformationData.pageHeadState;
    const { modalState } = this.state;
    const procedureData = {
      ...this.props.procedureInformationData.procedureInfoState,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
    };
    const params = {
      // @ts-ignore
      TaskId: this.procedureTaskId,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
    };

    return (
      <div className={styles.body}>
        <div className={styles.header}>
          <PageHeader
            title="Approve Primary Procedure Owner"
            receiveDate={receiveDate}
            requestBy={requestByName}
            status="Pending"
          />
        </div>
        <ProcedureBlock
          className={styles.approveProcedureBlock}
          child={<TaskInformation data={taskInformationData} />}
          testid="task-info-block-arrow"
          isShowArrow={true}
          isOpen={false}
          onShowDataLoad={() => {
            return StepService.getStepData(
              params,
              this.props.setTaskInfoData,
              this.setError,
              [StepBusinessType.taskInfo],
              StepService.getMergePayloadBySettingKey([StepBusinessType.taskInfo.settingKey])
            );
          }}
        />
        <ProcedureBlock
          child={
            <ReadOnlyProcedureFileSection
              procedureFileData={procedureTableData}
              procedureFileRef={procedureFileRef}
              clientServerPath={clientServerPath}
              savedInRadioValue={savedInRadioValue}
              jbProcedureSavedIn={jbProcedureSavedIn}
            />
          }
          testid="procedure-file-block-arrow"
          isShowArrow={true}
          isOpen={false}
          onShowDataLoad={() => {
            // @ts-ignore
            return StepService.getStepData(params, this.props.setProcedureFileData, this.setError, [
              StepBusinessType.procedureFile,
            ]);
          }}
        />
        <ProcedureBlock
          child={
            <ReadOnlySupportingFileSection
              supportingFileRef={supportingFileRef}
              supportingFileTableRef={supportingFileTableRef}
              supportingFileData={supportingTableData}
            />
          }
          testid="supporting-file-block-arrow"
          isShowArrow={true}
          isOpen={false}
          onShowDataLoad={() => {
            // @ts-ignore
            return StepService.getStepData(
              params,
              this.props.setSupportingFileData,
              this.setError,
              [StepBusinessType.supportingFile]
            );
          }}
        />
        <ProcedureBlock
          className={styles.ProcedureInfoSection}
          child={
            // @ts-ignore
            <ApproveProcedureInformation
              ref={procedureInfoRef}
              procedureData={procedureData}
              submitData={procedureData}
              noteDisabled={true}
              isPPODisabled={true}
              title="Procedure Information"
              className={styles.approveProcedureInformation}
              _showLoading={this.props._showLoading}
              closePage={this.props.closePage}
              isShowActionBtns={true}
              modalState={modalState}
              closeReturnModal={() => this.toggleReturnModal(false)}
              closeRejectModal={() => this.toggleRejectModal(false)}
              closeNormalModal={() => this.toggleNormalModal(false)}
            />
          }
          testid="reassign-ppo-block-arrow"
          isShowArrow={true}
          isOpen={true}
        />
        <ProcedureBlock
          className={styles.approveProcedureBlock}
          child={<ActiveShareTaskReadOnly shareTaskData={this.props.shareTask} />}
          testid="share-task-block-arrow"
          isShowArrow={true}
          isOpen={false}
          onShowDataLoad={() => {
            return StepService.getStepData(
              params,
              this.props.setShareTaskData,
              this.setError,
              [StepBusinessType.shareTask],
              StepService.getMergePayloadBySettingKey([StepBusinessType.shareTask.settingKey])
            );
          }}
        />
        <div className={styles.buttonsWrapper}>
          <div className={styles.informationBtns}>
            <Buttons
              color="grey"
              size="middle"
              onClick={() => this.checkStepPermission("return")}
              testid="approve-ppo-pending-return-btn"
            >
              Return to Revise
            </Buttons>
            <Buttons
              color="grey"
              size="middle"
              onClick={this.handleCancelClick}
              testid="approve-ppo-pending-cancel-btn"
            >
              Cancel
            </Buttons>
            <Buttons
              color="blue"
              size="middle"
              onClick={() => this.checkStepPermission("approve")}
              testid="approve-ppo-pending-approve-btn"
            >
              Approve
            </Buttons>
            <div className={styles.rejectBtn}>
              <Buttons
                color="red"
                size="middle"
                onClick={() => this.checkStepPermission("reject")}
                testid="approve-ppo-pending-reject-btn"
              >
                Reject
              </Buttons>
              <NormalToolTip
                element={
                  <div className={styles.rejectTipIcon}>
                    <img src={redTipIcon} alt="Reject" />
                  </div>
                }
                title="Reject means that the process will be terminated. The status will be changed back to the original status before this initiation."
                color="#FF5858"
                overlayClassName={styles.rejectTip}
                placement="right"
              />
            </div>
          </div>
        </div>
        <LostPermissionModal isModalOpen={this.state.noPermission} />
      </div>
    );
  }
}
